export default __webpack_public_path__ + "static/media/oh-hai.abb89589.gif";